import "./App.css";

import * as React from "react";
import { useEffect } from "react";
import { Routes, Route, Outlet, Link, useLocation } from "react-router-dom";

import { createRef } from 'react'

import { SwitchTransition, CSSTransition } from "react-transition-group";

import { Home } from "./components";
import { MiniApps } from "./components/Project/v2/mini-apps";
import { LoyaltyProgram } from "./components/Project/v2/loyalty-program";

import { Helmet } from "react-helmet";


const routes = [
  { index: true, element: <Home />, nodeRef: createRef() },
  { path: '/mini-apps', element: <MiniApps />, nodeRef: createRef() },
  { path: '/loyalty-program', element: <LoyaltyProgram />, nodeRef: createRef() },
  // { path: '/about', element: <About />, nodeRef: createRef() },
  // { path: 'projects/aula', element: <AULAProject />, nodeRef: createRef() },
  // { path: 'projects/aula-pro', element: <AULAProProject />, nodeRef: createRef() },
  // { path: 'projects/zhuldyz-zhoramal', element: <ZhuldyzZhoramalProject />, nodeRef: createRef() },
  // { path: 'projects/beeline', element: <BeelineProject />, nodeRef: createRef() },
]

const noMatchRef = createRef()


export default function App() {
  const location = useLocation();
  const { nodeRef } =
    routes.find((route) => {
      if (route.index) return location.pathname === '/';
      return route.path === location.pathname;
    }) ?? { nodeRef: noMatchRef };

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"
    }
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);

      // A small timeout can be helpful to ensure the element is rendered
      // before we try to scroll to it, especially with complex layouts.
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // If there is NO hash in the URL, scroll to the top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.hash]); // This effect re-runs every time the hash changes

  return (
    <div>

      <Helmet>
        <meta name="description" content="Amina Alen portfolio" />
      </Helmet>

      <SwitchTransition>
        <CSSTransition
          key={location.pathname}
          classNames="fade"
          nodeRef={nodeRef}
          timeout={350}
          unmountOnExit
          appear
        >
          <div ref={nodeRef}>

            < Routes location={location} >
              <Route path="/" element={<Layout />}>

                {routes.map((route) => (
                  <Route
                    key={route.path || 'index'} // Key needs a fallback for the index route
                    index={route.index}
                    path={route.path}
                    element={route.element}
                  />
                ))}

                <Route path="*" element={<NoMatch />} />
              </Route>
            </Routes >

          </div>

        </CSSTransition>
      </SwitchTransition>

    </div >
  );
}

function Layout() {
  return (
    <div className="v2-page-container">
      {/* <NavBar /> */}
      <Outlet />
      {/* <Footer /> */}
    </div>
  );
}

function NoMatch() {
  return (
    <div className="Page404">
      <h1 className="Page404-header">404</h1>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}